import { render, staticRenderFns } from "./create-student-for-no-enroll.vue?vue&type=template&id=6bb51903"
import script from "./create-student-for-no-enroll.vue?vue&type=script&lang=js"
export * from "./create-student-for-no-enroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports